// Ocean fauna (M18.1). PURE (ENG-1): the ambient effects two ocean mobs project on
// a nearby player — a dolphin grants Dolphin's Grace to a swimmer it is near, and a
// pufferfish puffs up when a player approaches and poisons anyone who touches it
// while puffed.
import { OCEAN } from '../config';

/** A dolphin grants Dolphin's Grace to a player within range who is in water. */
export function grantsDolphinGrace(dist: number, playerInWater: boolean): boolean {
  return playerInWater && dist <= OCEAN.DOLPHIN_GRACE_RANGE;
}

/** Duration (ticks) of the Dolphin's Grace it refreshes. */
export function dolphinGraceTicks(): number {
  return OCEAN.GRACE_TICKS;
}

/** A pufferfish inflates when a player comes within its puff range. */
export function pufferfishPuffed(dist: number): boolean {
  return dist <= OCEAN.PUFF_RANGE;
}

/** A puffed pufferfish poisons whatever touches it (within contact range). */
export function pufferfishPoisons(dist: number, puffed: boolean): boolean {
  return puffed && dist <= OCEAN.PUFF_CONTACT;
}

/** Duration (ticks) of the Poison a pufferfish inflicts. */
export function pufferfishPoisonTicks(): number {
  return OCEAN.POISON_TICKS;
}
